import { UrlParameters } from "../types/app";
import { AppInputContextState } from "../types/context";
import { parseUrlParams } from "../utils/urlParams";

export const getUrlParams = (): AppInputContextState => {
  let localVrm: string | undefined = undefined;
  let localMileage: string | undefined = undefined;
  let localQualificationId: string | undefined = undefined;
  let localJwt: string | undefined = undefined;

  if (process.env.NODE_ENV !== "production") {
    localVrm = process.env.REACT_APP_LOCAL_VRM;
    localMileage = process.env.REACT_APP_LOCAL_MILEAGE;
    localQualificationId = process.env.REACT_APP_LOCAL_QUALIFICATION_ID;
    localJwt = process.env.REACT_APP_LOCAL_JWT;
  }
  return {
    vrm: parseUrlParams(UrlParameters.Vrm, localVrm),
    mileage: parseInt(parseUrlParams(UrlParameters.Mileage, localMileage)) || 0,
    qualificationId: parseUrlParams(
      UrlParameters.QualificationId,
      localQualificationId,
    ),
    jwt: parseUrlParams(UrlParameters.Jwt, localJwt),
  };
};
